import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_CORGI_SSR_TIMINGS_RESPONSE_HEADER = createFcmDetails('corgi_ssr_timings_response_header', {
	owner: 'FE framework',
	context: 'Corgi SSR',
	description: `If enabled, and trace request header is sent, page HTTP response will contain a X-Change-SSR-Timings header with timing information.

		Make sure to only enable this in production temporarily if needed for debugging/investigation.`,
	import: false,
});
